module.exports = __webpack_public_path__ + "./images/p6.JPG?91ec265699930b562327d4ae3cd2ff23";


//////////////////
// WEBPACK FOOTER
// ./src/products/p6.JPG
// module id = 69
// module chunks = 0